// performance.jsx
import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Card,
  Typography,
  Select,
  MenuItem,
  TextField,
  Button,
  CircularProgress,
} from "@mui/material";

import { Chart } from "react-google-charts";

import config from '../twh/config';

const BASE_URL = config.reactApi_baseUrl + '/react-api/data-insights/performance-data';

const api_all_table = BASE_URL + "/GA4-table.php";
const api_all_chart = BASE_URL + "/GA4-chart.php";


export default function Performance() {
  const [dateRange, setDateRange] = useState("1 Week");
  const [customMode, setCustomMode] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");


/* =========================
   ALL PERFORMANCE TABLE
=========================*/
const [allTable, setAllTable] = useState([]);
const [loadingAllTable, setLoadingAllTable] = useState(false);

const fetchAllTable = async (range) => {
  try {
    setLoadingAllTable(true);

    const res = await fetch(api_all_table, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams({ dateRange: range }),
    });

    const json = await res.json();

    const rows = json?.response?.rows || [];

    const formatted = rows.map((row) => {
      const sessions = +row.metricValues[0].value;
      const totalUsers = +row.metricValues[1].value;
      const engagementRate = +row.metricValues[2].value;
      const eventCount = +row.metricValues[3].value;

      return {
        date: row.dimensionValues[0].value,
        sessions,
        totalUsers,
        engagementRate: engagementRate.toFixed(2),
        eventCount,
        percentage: sessions ? Math.round((eventCount / sessions) * 100) : 0,
      };
    });

    setAllTable(formatted);

  } catch (err) {
    console.error(err);
  } finally {
    setLoadingAllTable(false);
  }
};


/* =========================
   ALL PERFORMANCE CHART
=========================*/
const [chartData, setChartData] = useState([]);
const [loadingChart, setLoadingChart] = useState(false);

const fetchAllChart = async (range) => {
  try {
    setLoadingChart(true);

    const res = await fetch(api_all_chart, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams({ dateRange: range }),
    });

    const json = await res.json();

    setChartData(json || []);

  } catch (err) {
    console.error(err);
  } finally {
    setLoadingChart(false);
  }
};

  useEffect(() => {
    fetchAllTable(dateRange);
    fetchAllChart(dateRange);
  }, []);


 return (
    <Box>
      
      <Grid container spacing={2}>

          <Typography variant="h4" fontWeight={800}>
            PERFORMANCE PER CHANNEL
          </Typography>
          
          <Grid item size={{md:12}}>
            <Card sx={{ px: 3, py: 2, textAlign: "center", position: "relative" }}>
              {loadingAllTable  && (
                <CircularProgress size={15} sx={{ position: "absolute", right: 10, top: 10 }} />
              )}

              <Box sx={{ overflowX: "auto" }}>
                <table style={{ width: "100%", fontSize: "12px" }}>
                  <thead>
                    <tr style={{ textAlign: "right"}}>
                      <th style={{padding:'5px', textAlign: "left" }}>Channel</th>
                      <th style={{padding:'5px'}}>Sessions</th>
                      <th style={{padding:'5px'}}>Total Users</th>
                      <th style={{padding:'5px'}}>Engagement</th>
                      <th style={{padding:'5px'}}>Reserveringen</th>
                      <th style={{padding:'5px'}}>Conv %</th>
                    </tr>
                  </thead>

                  <tbody>
                    {allTable.map((row, i) => (
                      <tr key={i} style={{textAlign: "right"}}>
                        <td style={{borderTop:'1px solid #dddddd', padding:'5px', textAlign: "left"}}> {row.date}</td>
                        <td style={{borderTop:'1px solid #dddddd', padding:'5px'}}>{row.sessions}</td>
                        <td style={{borderTop:'1px solid #dddddd', padding:'5px'}}>{row.totalUsers}</td>
                        <td style={{borderTop:'1px solid #dddddd', padding:'5px'}}>{row.engagementRate} %</td>
                        <td style={{borderTop:'1px solid #dddddd', padding:'5px'}}>{row.eventCount}</td>
                        <td style={{borderTop:'1px solid #dddddd', padding:'5px'}}>{row.percentage} %</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Box>
            </Card>
          </Grid>
          
          <Grid item size={{md:12}}>
            <Card sx={{ px: 3, py: 2, textAlign: "center", position: "relative" }}>
              
              {loadingChart && (<CircularProgress size={15} sx={{ position: "absolute", right: 10, top: 10 }} />)}

              {chartData.length > 0 && (
                <Chart
                  chartType="AreaChart"
                  width="100%"
                  height="400px"
                  data={chartData}
                  options={{
                    title: "Session Source/Medium",
                    legend: { position: "top" },
                    chartArea: { width: "90%" },
                  }}
                />
              )}
            </Card>
          </Grid>
        
      </Grid>

        


     
    </Box>
  );
}